import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AuthRoutingModule } from './auth-routing.module';
import { LoginComponent } from './login/login.component';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { ForgotPasswordComponent } from './forgotPassword/forgot-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { UserVerificationComponent } from './verify/user-verification.component';
import { ErrorVerificationComponent } from './verify/errorVerification/errorVerification.component';
import { SuccessVerificationComponent } from './verify/verificationSuccessful/successVerification.component';
import { RegistrationComponent } from './registration/registration.component';
import { GoogleSigninButtonModule } from '@abacritt/angularx-social-login';
import { AuthService } from '../shared/services/auth.service';
import { CongratulationsComponent } from './congratulations/congratulations.component';

@NgModule({
	declarations: [
		LoginComponent,
		RegistrationComponent,
		UserVerificationComponent,
		ForgotPasswordComponent,
		ResetPasswordComponent,
		ErrorVerificationComponent,
		SuccessVerificationComponent,
		CongratulationsComponent
	],
	imports: [
		CommonModule,
		ReactiveFormsModule,
		SharedModule,
		AuthRoutingModule,
		NgSelectModule,
		GoogleSigninButtonModule
	],
	providers: [AuthService]
})
export class AuthModule {}
